// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"63":"51298af1","492":"6afe21c2"}[chunkId] + ".css";
};